import { phoneInputFormat } from 'util/formatters'

export const TIMELY_PHONE_UNFORMATED = '8334846359'
export const TIMELY_PHONE = phoneInputFormat(TIMELY_PHONE_UNFORMATED)
